import * as React from "react";
import {
  Button,
  Grid,
  Header,
  Input,
  List,
  Popup,
  Segment,
  Dropdown
} from "semantic-ui-react";
import { Link } from "..";
import { COLORS } from "../../../constants";
import { Text } from "../text";

interface IFilterType {
  label: string;
  value: any;
}

interface ITableLayout {
  title?: string;
  styleContent?: any;
  children: any;
  onClick?: () => void;
  onSelected?: (label: string, value: any) => void;
  onSelectedLawtype?: (label: string, value: any) => void;
  onSelectedFinanceltype?: (label: string, value: any) => void;
  searchValue?: string;
  searchPopup?: string;
  onSearch?: (item: string) => void;
  orgfilterType?: any;
  selected?: any;
  filterType?: IFilterType[];
  placeholderSearchBar?: string;
  buttonType?: boolean;
  hideSearchBar?: boolean;
  basic?: boolean;
  nonePadded?: boolean;
  loading?: boolean;
  footer?: any;
  extraSearchComponent?: any;
  superExtraComponent?: any; // เพิ่ม prop ใหม่
  filterlawTypes?: IFilterType[];
  filterfinancelTypes?: IFilterType[];
  fullsearchBar?: boolean;
}

class TableLayout extends React.Component<ITableLayout> {
  public render() {
    const {
      children,
      styleContent,
      title,
      filterType,
      onSelected,
      selected,
      hideSearchBar,
      nonePadded,
      basic,
      loading,
      footer,
      extraSearchComponent,
      superExtraComponent, // เพิ่มตัวแปรนี้
      orgfilterType,
      filterlawTypes,
      filterfinancelTypes,
      fullsearchBar
    } = this.props;

    // คำนวณ columns สำหรับ grid
    const calculateColumns = () => {
      if (!title && hideSearchBar) return 1;
      if (extraSearchComponent && superExtraComponent) return 4; // เพิ่มกรณีมี superExtraComponent
      if (extraSearchComponent) return 3;
      return 2;
    };

    // คำนวณขนาด column สำหรับแต่ละส่วน
    const getColumnSizes = () => {
      if (!title && hideSearchBar) {
        return { main: 16, extra: 0, super: 0, filter: 0 };
      }
      
      if (extraSearchComponent && superExtraComponent) {
        return { main: 7, extra: 6, super: 3, filter: 0 };
      }
      
      if (extraSearchComponent) {
        return { main: 7, extra: 6, super: 0, filter: 3 };
      }
      
      return { main: 7, extra: 0, super: 0, filter: 9 };
    };

    const columnSizes = getColumnSizes();
    
    return (
      <Grid padded={nonePadded ? false : true}>
        <Grid.Row columns={calculateColumns()} verticalAlign="top">
          {(!title && hideSearchBar) || fullsearchBar ? null : (
            <Grid.Column 
              computer={columnSizes.main} 
              tablet={columnSizes.main} 
              mobile={16} 
              floated="left"
              verticalAlign="middle"
            >
              {!title ? this.renderSearchBar() : this.renderText()}
            </Grid.Column>
          )}
          
          {fullsearchBar ? 
            <Grid.Column computer={16} tablet={16} mobile={16} floated="left">
              <Header as="h4" style={{ marginBottom: "10px" }}>
                {title}
              </Header>
              {title ? this.renderSearchBar() : this.renderText()}
            </Grid.Column> : null
          }
          
          {/* Extra Search Component */}
          {extraSearchComponent ? (
            <Grid.Column
              textAlign="right"
              computer={columnSizes.extra}
              tablet={columnSizes.extra}
              mobile={16}
              floated="right"
              verticalAlign="middle"
            >
              {extraSearchComponent}
            </Grid.Column>
          ) : null}

          {/* Super Extra Component - ส่วนใหม่ที่เพิ่มเข้ามา */}
          {superExtraComponent ? (
            <Grid.Column
              textAlign="right"
              computer={columnSizes.super}
              tablet={columnSizes.super}
              mobile={16}
              floated="right"
              verticalAlign="middle"
            >
              {superExtraComponent}
            </Grid.Column>
          ) : null}

          {/* Filter Component */}
          <Grid.Column
            textAlign="right"
            computer={columnSizes.filter}
            tablet={columnSizes.filter}
            mobile={16}
            floated="right"
            verticalAlign="middle"
          >
            {filterType !== undefined &&
            selected !== undefined &&
            onSelected !== undefined
              ? this.renderList()
              : null}
          </Grid.Column>
        </Grid.Row>
  
        {/* Organization dropdowns row - ไม่เปลี่ยนแปลง */}
        {orgfilterType && filterType !== undefined && (
          <Grid.Row columns={1} style={{ marginTop: '-10px' }}>
          <Grid.Column>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column' as 'column',
              width: '100%',
              gap: '15px',
              paddingLeft: '350px'
            }}>
              {filterlawTypes && filterfinancelTypes && (
                <div style={{ 
                  display: 'flex', 
                  width: '100%',
                  gap: '20px',
                  flexWrap: 'wrap' as 'wrap'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    flex: '1 1 400px', 
                    minWidth: '400px',
                    maxWidth: '600px'
                  }}>
                    <label style={{ 
                      marginRight: '10px', 
                      whiteSpace: 'nowrap' as 'nowrap',
                      overflow: 'visible' as 'visible'
                    }}>
                      สถานะตามกฏหมาย: บริหารหนี้สาธารณะจัดเป็น 
                    </label>
                    <div style={{ flex: 1, minWidth: '150px' }}>
                      <Dropdown
                        selection
                        style={{ width: '100%' }}
                        placeholder="ทั้งหมด"
                        options={filterlawTypes.map((type, index) => ({
                          key: index,
                          text: type.label,
                          value: type.value,
                        }))}
                        className="extended-dropdown-width"
                        fluid={true}
                        search={true}
                        clearable={true}
                        scrolling={true}
                        onChange={(e, { value }) => {
                          const selectedOption = filterlawTypes.find(type => type.value === value);
                          if (selectedOption && this.props.onSelectedLawtype) {
                            this.props.onSelectedLawtype(selectedOption.label, selectedOption.value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    flex: '1 1 300px',
                    minWidth: '300px'
                  }}>
                    <label style={{ 
                      marginRight: '10px', 
                      whiteSpace: 'nowrap' as 'nowrap'
                    }}>
                      วินัยการเงินการคลังของรัฐ 
                    </label>
                    <div style={{ flex: 1, minWidth: '150px' }}>
                      <Dropdown
                        selection
                        style={{ width: '100%' }}
                        placeholder="ทั้งหมด"
                        options={filterfinancelTypes.map((type, index) => ({
                          key: index,
                          text: type.label,
                          value: type.value,
                        }))}
                        className="extended-dropdown-width"
                        fluid={true}
                        search={true}
                        clearable={true}
                        scrolling={true}
                        onChange={(e, { value }) => {
                          const selectedOption = filterfinancelTypes.find(type => type.value === value);
                          if (selectedOption && this.props.onSelectedFinanceltype) {
                            this.props.onSelectedFinanceltype(selectedOption.label, selectedOption.value);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
        )}
  
        <Grid.Row columns={1} style={{ ...styles.row }}>
          <Grid.Column>
            <Segment
              basic={basic}
              style={{ ...styles.segment, ...styleContent }}
              loading={loading}
            >
              {children}
            </Segment>
          </Grid.Column>
        </Grid.Row>
        {footer ? (
          <Grid.Row textAlign={"right"} style={{ ...styles.row }}>
            <Grid.Column>{footer}</Grid.Column>
          </Grid.Row>
        ) : null}
      </Grid>
    );
  }

  private renderText() {
    const { title } = this.props;
    return <Header style={styles.header}>{title}</Header>;
  }

  private renderSearchBar() {
    const {
      placeholderSearchBar,
      searchValue,
      onSearch,
      searchPopup
    } = this.props;
    return (
      <Popup
        content={searchPopup}
        disabled={!searchPopup}
        trigger={
          <Input
            fluid
            icon="search"
            iconPosition="left"
            placeholder={placeholderSearchBar}
            value={searchValue}
            onChange={(event: any, data: any) => onSearch!(data.value)}
          />
        }
      />
    );
  }

  private renderORGListDropdown() {
    const { filterType, onSelected, selected, filterlawTypes, filterfinancelTypes, onSelectedLawtype, onSelectedFinanceltype } = this.props;
    
    const options = filterType!.map((type, index: number) => ({
      key: index,
      text: type.label,
      value: type.value,
    }));
    
    const isValidSelection = (value: any) => {
      return filterType!.some(type => type.value === value);
    };
    const processedOptions = options.filter(option => {
      return option.text && option.value !== undefined;
    });
    
    const handleSelectionChange = (value: any) => {
      const selectedOption = filterType!.find((type) => type.value === value);
      if (selectedOption && onSelected) {
        onSelected(selectedOption.label, selectedOption.value);
      }
    };
  
    const secondDropdownOptions = filterlawTypes!.map((type, index: number) => ({
      key: index,
      text: type.label,
      value: type.value,
    }));
    const thirdDropdownOptions = filterfinancelTypes!.map((type, index: number) => ({
      key: index,
      text: type.label,
      value: type.value,
    }));
    
    const handleSecondDropdownChange = (value: any) => {
      const selectedSecondOption = filterlawTypes!.find((type) => type.value === value);
      if (selectedSecondOption && onSelectedLawtype) {
        onSelectedLawtype(selectedSecondOption.label, selectedSecondOption.value);
      }
    };
    
    const handleThirdDropdownChange = (value: any) => {
      const selectedThirdOption = filterfinancelTypes!.find((type) => type.value === value);
      if (selectedThirdOption && onSelectedFinanceltype) {
        onSelectedFinanceltype(selectedThirdOption.label, selectedThirdOption.value);
      }
    };
  
    return (
      <React.Fragment>
        <div style={{
          display: 'flex',
          flexDirection: 'column' as 'column',
          width: '100%',
          gap: '15px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            width: '100%'
          }}>
            <label style={{ 
              marginRight: '10px', 
              whiteSpace: 'nowrap' as 'nowrap'
            }}>
              ประเภทหน่วยงาน 
            </label>
            <div style={{ flex: 1 }}>
              <Dropdown
                selection
                style={{ width: '100%' }}
                value={selected}
                placeholder="ทั้งหมด"
                options={processedOptions}
                className="extended-dropdown-width"
                fluid={true}
                search={true}
                clearable={true}
                scrolling={true}
                onChange={(e, { value }) => {
                  if (isValidSelection(value)) {
                    handleSelectionChange(value);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  private renderList() {
    const { filterType, selected, onSelected, buttonType, orgfilterType } = this.props;
    if (buttonType) {
      return (
        <Button.Group>
          {filterType!.map((type, index: number) => {
            return (
              <Button
                key={index}
                onClick={() => onSelected!(type.label, type.value)}
                style={{
                  backgroundColor:
                    selected === type.label || selected === type.value
                      ? COLORS.navyBlueOnLighBG
                      : COLORS.transparent,
                  borderColor:
                    selected === type.label || selected === type.value
                      ? COLORS.navyBlueOnLighBG
                      : COLORS.borderDarkGrey,
                  borderWidth: 1,
                  borderStyle: "solid"
                }}
              >
                <Text
                  style={{
                    color:
                      selected === type.label || selected === type.value
                        ? COLORS.white
                        : "black"
                  }}
                >
                  {type.label}
                </Text>
              </Button>
            );
          })}
        </Button.Group>
      );
    }else if(orgfilterType) {
      return this.renderORGListDropdown()
    }
    else {
      return (
        <List horizontal>
          {filterType!.map((type, index: number) => {
            return (
              <List.Item key={index} style={styles.listItem}>
                <List.Content>
                  <List.Header>
                    <Link
                      shade={3}
                      size="large"
                      hideUnderline={
                        !(selected === type.label || selected === type.value)
                      }
                      onClick={() => onSelected!(type.label, type.value)}
                    >
                      {type.label}
                    </Link>
                  </List.Header>
                </List.Content>
              </List.Item>
            );
          })}
        </List>
      );
    }
  }
}

const styles = {
  listItem: {
    paddingTop: 14,
    paddingBottom: 14
  },
  row: {
    paddingTop: 0
  },
  segment: {
    padding: 0,
    boxShadow: "none",
    border: "0"
  },
  header: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "95%"
  }
};

export default TableLayout;